import React from "react";
import { Route, Switch } from "react-router-dom";
import { Auth } from "_helpers";

import AvailableStocks from "./AvailableStocks";
import BinWiseBalance from "./BinWiseBalance";
import SupplierWiseBalance from "./SupplierWiseBalance";
import StockInOutSummary from "./StockInOutSummary";

import PrymAvailableStocks from "./prym/AvailableStocks";
import PrymBinWiseBalance from "./prym/BinWiseBalance";

import SiluetaAvailableStocks from "./silueta/AvailableStocks";

import StrGrAvailableStocks from "./str_gr/AvailableStocks";

import StrRmAvailableStocks from "./str_rm/AvailableStocks";
import StrRmBinWiseBalance from "./str_rm/BinWiseBalance";
import StrRmSupplierWiseBalance from "./str_rm/SupplierWiseBalance";

import OtrAvailableStocks from "./otr/AvailableStocks";
import OtrBinWiseBalance from "./otr/BinWiseBalance";

import TiepAvailableStocks from "./tiep/AvailableStocks";
import TiepBinWiseBalance from "./tiep/BinWiseBalance";
import TiepAgingReports from "./tiep/AgingReports";
import TiepAgingLiability from "./tiep/AgingLiability";

import AquaAvailableStocks from "./aqua/AvailableStocks";
import AquaBinWiseBalance from "./aqua/BinWiseBalance";
import AquaStockInOutSummary from "./aqua/StockInOutSummary";
import AquaStockAging from "./aqua/StocksAging";
import TiepAvailableLiabilities from "./tiep/AvailableLiabilities";
import MudForms from "./tiep/MudForms";
import { TiepWastage } from "./tiep/wastage/Index";

function Reports({ match }) {
  const { path } = match;
  const loggedInCustomerCode = Auth.getProfile().comp_code;
  if (loggedInCustomerCode === "SILUETA") {
    return (
      <Switch>
        <Route exact path={path} component={SiluetaAvailableStocks} />
        <Route
          path={`${path}/available-stocks`}
          component={SiluetaAvailableStocks}
        />
      </Switch>
    );
  } else if (loggedInCustomerCode === "PRYM") {
    return (
      <Switch>
        <Route exact path={path} component={PrymAvailableStocks} />
        <Route
          path={`${path}/available-stocks`}
          component={PrymAvailableStocks}
        />
        <Route
          path={`${path}/bin-wise-balance`}
          component={PrymBinWiseBalance}
        />
        <Route path={`${path}/inout-summary`} component={StockInOutSummary} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "STR_GR") {
    return (
      <Switch>
        <Route exact path={path} component={StrGrAvailableStocks} />
        <Route
          path={`${path}/available-stocks`}
          component={StrGrAvailableStocks}
        />
      </Switch>
    );
  } else if (loggedInCustomerCode === "STR") {
    return (
      <Switch>
        <Route exact path={path} component={StrRmAvailableStocks} />
        <Route
          path={`${path}/available-stocks`}
          component={StrRmAvailableStocks}
        />
        <Route
          path={`${path}/bin-wise-balance`}
          component={StrRmBinWiseBalance}
        />
        <Route
          path={`${path}/supplier-wise-balance`}
          component={StrRmSupplierWiseBalance}
        />
        <Route path={`${path}/inout-summary`} component={StockInOutSummary} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "OTR") {
    return (
      <Switch>
        <Route exact path={path} component={OtrAvailableStocks} />
        <Route
          path={`${path}/available-stocks`}
          component={OtrAvailableStocks}
        />
        <Route
          path={`${path}/bin-wise-balance`}
          component={OtrBinWiseBalance}
        />
        <Route path={`${path}/inout-summary`} component={StockInOutSummary} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "TIEP") {
    return (
      <Switch>
        <Route exact path={path} component={TiepAvailableStocks} />
        <Route
          path={`${path}/available-stocks`}
          component={TiepAvailableStocks}
        />
        <Route
          path={`${path}/available-liability`}
          component={TiepAvailableLiabilities}
        />
        <Route path={`${path}/aging-reports`} component={TiepAgingReports} />
        <Route
          path={`${path}/liability-aging`}
          component={TiepAgingLiability}
        />
        <Route path={`${path}/mud-forms`} component={MudForms} />

        <Route path={`${path}/wastage`} component={TiepWastage} />
        <Route
          path={`${path}/bin-wise-balance`}
          component={TiepBinWiseBalance}
        />
        <Route path={`${path}/inout-summary`} component={StockInOutSummary} />
      </Switch>
    );
  } else if (loggedInCustomerCode === "AQUA") {
    return (
      <Switch>
        <Route exact path={path} component={AquaAvailableStocks} />
        <Route
          path={`${path}/available-stocks`}
          component={AquaAvailableStocks}
        />
        <Route path={`${path}/stocks-aging`} component={AquaStockAging} />
        <Route
          path={`${path}/bin-wise-balance`}
          component={AquaBinWiseBalance}
        />
        <Route
          path={`${path}/inout-summary`}
          component={AquaStockInOutSummary}
        />
      </Switch>
    );
  } else {
    return (
      <Switch>
        <Route exact path={path} component={AvailableStocks} />
        <Route path={`${path}/available-stocks`} component={AvailableStocks} />

        <Route path={`${path}/bin-wise-balance`} component={BinWiseBalance} />
        <Route
          path={`${path}/supplier-wise-balance`}
          component={SupplierWiseBalance}
        />
        <Route path={`${path}/inout-summary`} component={StockInOutSummary} />
      </Switch>
    );
  }
}

export { Reports };
